<div class="business-setting-container">
  <kt-base-modal [title]="'TITLE.BUSINESS_SETTING_TITLE'">
    <div modal-body>

      <div #wizard class="kt-grid kt-wizard-v2 kt-wizard-v2--white" id="kt_wizard_v2" data-ktwizard-state="step-first">
        <!-- begin: Form Wizard Nav -->
        <div class="kt-grid__item kt-wizard-v2__aside">
          <div class="kt-widget kt-widget--user-profile-1 w-100">
            <div class="kt-widget__head mb-4">
              <div class="kt-widget__media">
                <img *ngIf="businessBrandingForm.controls.business_logo?.value"
                  [src]="businessBrandingForm.controls.business_logo?.value" alt="image"
                  style="width: 120px;height: 60px;">
              </div>
              <div class="kt-widget__content ps-2">
                <div class="kt-widget__section">
                  <span class="kt-widget__username text-dark">
                    {{business?.business_name}}
                  </span>
                </div>
              </div>
            </div>

            <div class="kt-widget__body">
              <div class="kt-widget__items">

                <!-- begin: step 1 branding -->
                <a class="kt-widget__item " href="javascript:;" data-ktwizard-type="step"
                  (click)="onStepClick(formConstants.BRAND_FORM)" data-ktwizard-state="current"
                  *ngxPermissionsOnly="PermissionV2.BUSINESS_SETTINGS_ACCESS">
                  <span class="kt-widget__section d-flex">
                    <span class="">
                      <svg-icon class="svg_icon13x13 d-inline " src="assets/media/iq-svg/without_circle/icon_set_3/branding.svg"></svg-icon>
                    </span>
                    <span class="kt-widget__desc">
                      {{'BUSINESS_SETTING.BRANDING' | translate}}
                    </span>
                  </span>
                </a>
                <!-- end: step 1 branding -->

                <!-- begin: step 2 business detail -->
                <a href="javascript:;" data-ktwizard-type="step" (click)="onStepClick(formConstants.DETAIL_FORM)"
                  class="kt-widget__item" *ngxPermissionsOnly="PermissionV2.BUSINESS_SETTINGS_ACCESS">
                  <span class="kt-widget__section d-flex">
                    <span class="">
                      <svg-icon class="svg_icon13x13 d-inline " src="assets/media/iq-svg/without_circle/icon_set_3/bussiness_details.svg"></svg-icon>
                    </span>
                    <span class="kt-widget__desc">
                      {{'BUSINESS_SETTING.BUSINESS_DETAIL' | translate}}
                    </span>
                  </span>
                </a>
                <!-- end: step 2 business detail -->

    
                     <!-- begin: step 3 business LAbel Change  -->
                     <a href="javascript:;" data-ktwizard-type="step" (click)="onStepClick(formConstants.DETAIL_LABEL_FORM)"
                     class="kt-widget__item" *ngxPermissionsOnly="PermissionV2.BUSINESS_SETTINGS_ACCESS">
                     <span class="kt-widget__section d-flex">
                       <span class="">
                         <svg-icon class="svg_icon13x13 d-inline " src="assets/media/iq-svg/without_circle/icon_set_3/business_preference.svg"></svg-icon>
                       </span>
                       <span class="kt-widget__desc">
                         {{'BUSINESS_SETTING.BUSINESS_LABEL_SETTING' | translate}}
                       </span>
                     </span>
                   </a>

                   

                   
                   <!-- end: step 3 business LAbel Change  -->


                <!-- begin: step 3 reward detail -->
                <a class="kt-widget__item " href="javascript:;" data-ktwizard-type="step"
                  (click)="onStepClick(formConstants.REWARD_FORM)"
                  *ngxPermissionsOnly="PermissionV2.BUSINESS_SETTINGS_ACCESS">
                  <span class="kt-widget__section d-flex">
                    <span class="">
                      <svg-icon class="svg_icon13x13 d-inline " src="assets/media/iq-svg/without_circle/icon_set_3/reward.svg"></svg-icon>
                    </span>
                    <span class="kt-widget__desc">
                      {{'BUSINESS_SETTING.REWARD' | translate}}
                    </span>
                  </span>
                </a>
                <!-- end: step 3 reward detail -->

                <!-- begin: step 4 business plan -->
                <!-- <a class="kt-widget__item " href="javascript:;" data-ktwizard-type="step"
                  (click)="onStepClick(formConstants.PLAN_FORM)"
                  *ngxPermissionsOnly="permissionConstant.MASTER_BUSINESS.BUSINESS_PLAN">
                  <span class="kt-widget__section">
                    <span class="kt-widget__icon">
                    </span>
                    <span class="kt-widget__desc">
                      {{'BUSINESS_SETTING.PLAN' | translate}}
                    </span>
                  </span>
                </a> -->
                <!-- end: step 4 business plan -->

              </div>
            </div>
          </div>
        </div>
        <!-- end: Form Wizard Nav -->

        <div class="kt-grid__item kt-grid__item--fluid kt-wizard-v2__wrapper">
          <!--begin: Form Wizard Form-->
          <kt-loader [showLoader]="loading()">
            <form class="kt-form" id="kt_form" (ngSubmit)="saveBusiness()">

              <!--begin: Form Wizard Step 1-->
              <div class="kt-wizard-v2__content" data-ktwizard-type="step-content" data-ktwizard-state="current"
                *ngxPermissionsOnly="PermissionV2.BUSINESS_SETTINGS_ACCESS">
                <div class="kt-heading kt-heading--md kt-heading--space-sm"> {{'BUSINESS_SETTING.BRANDING' | translate}}
                </div>
                <div class="kt-portlet__body kt-business-overflow">
                  <div class="container">
                    <kt-formly [form]="businessBrandingForm" [fieldList]="businessBrandingFormControl" [options]="{}"
                      [values]="{}">
                    </kt-formly>
                  </div>
                </div>
              </div>
              <!--end: Form Wizard Step 1-->

              <!--begin: Form Wizard Step 2-->
              <div class="kt-wizard-v2__content" data-ktwizard-type="step-content"
                *ngxPermissionsOnly="PermissionV2.BUSINESS_SETTINGS_ACCESS">
                <div class="kt-heading kt-heading--md kt-heading--space-sm">
                  {{'BUSINESS_SETTING.BUSINESS_DETAIL' | translate}}
                </div>
                <div class="kt-portlet__body kt-business-overflow">
                  <div class="container">
                    <kt-formly [form]="businessDetailForm" [fieldList]="businessDetailFormControl"
                      [options]="this.options" [values]="{}">
                    </kt-formly>
                  </div>
                </div>
              </div>
              <!--end: Form Wizard Step 2-->

              <div class="kt-wizard-v2__content" data-ktwizard-type="step-content"
              *ngxPermissionsOnly="PermissionV2.BUSINESS_SETTINGS_ACCESS">
              <div class="kt-heading kt-heading--md kt-heading--space-sm">
                {{'BUSINESS_SETTING.BUSINESS_LABEL_SETTING' | translate}}
                  <span [container]="'body'" #t="ngbTooltip" [ngbTooltip]="'Customize your iQCheckPoint experience by renaming default labels to match your business terminology.'" [tooltipClass]="'custom-tooltip'">
                    <svg-icon class="svg_icon13x13 d-inline cursor-pointer" src="assets/media/iq-svg/without_circle/icon_set_3/information.svg"></svg-icon>
                  </span>
              </div>
              <div class="kt-portlet__body kt-business-overflow">
                <div class="container">
                  <kt-formly [form]="businessDetailLabelForm" [fieldList]="businessDetailLableFormControl" [options]="{}"
                    [values]="{}">
                  </kt-formly>
                </div>
              </div>
            </div>


              <!--begin: Form Wizard Step 3-->
              <div class="kt-wizard-v2__content" data-ktwizard-type="step-content"
                *ngxPermissionsOnly="PermissionV2.BUSINESS_SETTINGS_ACCESS">
                <div class="kt-heading kt-heading--md kt-heading--space-sm">
                  {{'BUSINESS_SETTING.REWARD' | translate}}
                </div>
                <div class="kt-portlet__body kt-business-overflow">
                  <div class="container">
                    <kt-formly [form]="businessRewardForm" [fieldList]="businessRewardFormControl" [options]="{}"
                      [values]="{}">
                    </kt-formly>
                  </div>
                </div>
              </div>
              <!--end: Form Wizard Step 3-->

              <!--begin: Form Wizard Step 4-->
              <!-- <div class="kt-wizard-v2__content" data-ktwizard-type="step-content"
                *ngxPermissionsOnly="permissionConstant.MASTER_BUSINESS.BUSINESS_PLAN">
                <div class="kt-heading kt-heading--md kt-heading--space-sm">Details</div>
                <div class="kt-portlet__body kt-business-overflow ">
                  <div class="container h-100">
                    <div class="d-flex bg-light text-dark align-items-center justify-content-center h5 h-100">
                      Coming Soon
                    </div>

                  </div>
                </div>
              </div> -->
              <!--end: Form Wizard Step 4-->


              <!--begin: Form Actions -->
              <div class="kt-form__actions">
                <!-- <div class="btn btn-secondary btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u"
              data-ktwizard-type="action-prev">
              {{'BUTTON.PREVIOUS' | translate}}
            </div>
            <div class="btn btn-success btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u"
              data-ktwizard-type="action-submit">
              {{'BUTTON.CHANGE_PLAN' | translate}}
            </div>
            <div class="btn btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u"
              data-ktwizard-type="action-next">
              {{'BUTTON.NEXT_STEP' | translate}}
            </div> -->
                <kt-button [buttonConfig]="buttonConfig.CANCEL_BUTTON_CONFIG" (buttonClick)="activeModal.close()">
                </kt-button>
                <ng-container  *ngxPermissionsOnly="PermissionV2.BUSINESS_SETTINGS_MANAGE" >
                <kt-button [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG">
                </kt-button>
               </ng-container>   
              </div>
              <!--end: Form Actions -->
            </form>
          </kt-loader>
          <!--end: Form Wizard Form-->
        </div>
      </div>
    </div>
  </kt-base-modal>
</div>